
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import { useLocation, useNavigate } from 'react-router';
import { EquipmentModel } from '../models/EquipmentModel';
import { equipmentPageName } from '../components/PageName';
import FormDropDownList from '../components/FormDropDownList';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useLazyGetEquipmentByIdQuery, useLazyGetFileQuery, useUpdateEquipmentMutation, useLazyGetEquipmentTypeDDLQuery, useLazyGetRealTimeTypeDDLQuery } from '../features/equipment/EquipmentSlice';
import { set } from 'date-fns';
import { useTranslation } from "react-i18next";

const AddEquipmentPage = () => {
    const getLocation = useLocation();
    const equipmentId = getLocation?.state;
    //console.log(getLocation?.state)
    const [equipmentType, setType] = useState({ id: 0, fullName: "" });
    const [realTimeType, setRRT] = useState({ id: 0, name: "" });
    const [rfid, setRfid] = useState("");
    const [equipmentNum, setEquipmentNum] = useState("");
    const [equipmentName, setEquipmentName] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [model, setModel] = useState("");
    const [serial, setSerial] = useState("");
    const [purchaseDate, setPurchaseDate] = useState(dayjs(null));
    const [expiryDate, setExpiryDate] = useState(dayjs(null));
    const [calDate, setCalDate] = useState(dayjs(null));
    // const [calPeriod, setCalPeriod] = React.useState("");
    // const [calPeriodType, setCalPeriodType] = React.useState("0");
    const certificationFileInputRef = useRef<HTMLInputElement>(null);
    const equipmentPhotoFileInputRef = useRef<HTMLInputElement>(null);
    const [open, setOpen] = useState(false);
    const [setEquipmentDetail, equipmentDetail] = useUpdateEquipmentMutation();
    const [certFileBinary, setCertFileBinary] = useState<File | null>(null);
    const [certFileName, setCertFileName] = useState({ id: "", name: "" });
    const [equipmentPhotoFileBinary, setEquipmentPhotoFileBinary] = useState<File | null>(null);
    const [equipmentPhotoFileName, setEquipmentPhotoFileName] = useState({ id: "", name: "" });
    const [getFile, file] = useLazyGetFileQuery();
    const [getEquipmentById, equipmentById] = useLazyGetEquipmentByIdQuery();
    const [getEquipmentTypeDDL, equipmentTypeDDL] = useLazyGetEquipmentTypeDDLQuery();
    const [getRealTimeTypeDDL] = useLazyGetRealTimeTypeDDLQuery();
    const [realTimeTypeDDL, setRRTDDL] = useState([{ id: 0, name: "" }]);

    //暫時用
    const tempType = ([{ id: 1, name: "PPE" }, { id: 2, name: "SSS" }]);
    // const [equipment, setEquipment] = useState<EquipmentModel>();

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        console.log(equipmentType);
    }, [equipmentType])

    useEffect(() => {
        let eqDDL: any;
        let rrDDL: any;
        Promise.all([getEquipmentTypeDDL(), getRealTimeTypeDDL(), getEquipmentById(equipmentId)])
            .then(([ddlRes, rttRes, res]) => {
                if (ddlRes?.status === 'fulfilled') {
                    eqDDL = ddlRes?.data;
                    if (rttRes?.status === 'fulfilled') {
                        rrDDL = rttRes?.data;
                        //let t = [{id: 0, name: ""}, ...rttRes?.data];
                        setRRTDDL([{ id: "0", name: "None" }, ...rttRes?.data]);
                    }
                    if (res.status === 'fulfilled') {
                        console.log(res);
                        //console.log(temp);
                        let a = eqDDL?.find((item: any) => item?.id === res?.data?.equipmentTypeId);
                        let b = rrDDL?.find((item: any) => item?.id === res?.data?.realTimeTypeId);
                        console.log(a);
                        setType({ id: res?.data?.equipmentTypeId, fullName: a?.fullName ? a?.fullName : "" });
                        setRRT({ id: res?.data?.realTimeTypeId == null ? 0 : res?.data?.realTimeTypeId, name: b?.name ? b?.name : "None" });
                        setRfid(res?.data?.rfidNumber);
                        setEquipmentNum(res?.data?.equipmentNumber);
                        setEquipmentName(res?.data?.equipmentName);
                        setManufacturer(res?.data?.manufacturer);
                        setModel(res?.data?.modelNumber);
                        setSerial(res?.data?.serialNumber);
                        setPurchaseDate((dayjs)(res?.data?.purchaseDate, 'DD/MM/YYYY'));
                        setExpiryDate((dayjs)(res?.data?.expiryDate, 'DD/MM/YYYY'));
                        setCalDate((dayjs)(res?.data?.certDueDate, 'DD/MM/YYYY'));
                        setCertFileName({ id: res?.data?.certificationFile?.Id, name: res?.data?.certificationFile?.Name });
                        setCertFileBinary(res?.data?.certificationFile);
                        setEquipmentPhotoFileName({ id: res?.data?.equipmentPhoto?.Id, name: res?.data?.equipmentPhoto?.Name });
                        setEquipmentPhotoFileBinary(res?.data?.equipmentPhoto);
                    }
                }
            });
        /* getEquipmentTypeDDL().then((ddlRes) => {
            if (ddlRes?.status == 'fulfilled') {
                temp = ddlRes?.data;
                console.log(temp);
                console.log(ddlRes?.data);
            }
        });
        getEquipmentById(equipmentId)
            .then((res) => {
                if (res.status == 'fulfilled') {
                    console.log(res);
                    const a = temp?.data?.find((item: any) => item?.id?.toString() === res?.data?.equipmentTypeId.toString());
                    //console.log(a);
                    console.log(temp);
                    setType({ id: res?.data?.equipmentTypeId, shortName: a?.shortName ? a?.shortName : "" });
                    setRfid(res?.data?.rfidNumber);
                    setEquipmentNum(res?.data?.equipmentNumber);
                    setEquipmentName(res?.data?.equipmentName);
                    setManufacturer(res?.data?.manufacturer);
                    setModel(res?.data?.modelNumber);
                    setSerial(res?.data?.serialNumber);
                    setPurchaseDate((dayjs)(res?.data?.purchaseDate, 'DD/MM/YYYY'));
                    setExpiryDate((dayjs)(res?.data?.expiryDate, 'DD/MM/YYYY'));
                    setCalDate((dayjs)(res?.data?.certDueDate, 'DD/MM/YYYY'));
                    setCertFileName({ id: res?.data?.certificationFile?.Id, name: res?.data?.certificationFile?.Name });
                    setCertFileBinary(res?.data?.certificationFile);
                    setEquipmentPhotoFileName({ id: res?.data?.equipmentPhoto?.Id, name: res?.data?.equipmentPhoto?.Name });
                    setEquipmentPhotoFileBinary(res?.data?.equipmentPhoto);
                }
            }) */
    }, [])
    const handleOnComfirm = async () => {
        const form = new FormData();
        form.append('id', equipmentId);
        form.append('EquipmentTypeId', equipmentType?.id?.toString());
        console.log(realTimeType);
        form.append('RealTimeTypeId', (realTimeType?.id != 0 || realTimeType?.id == undefined || realTimeType?.id == null) ? realTimeType?.id?.toString() : "");
        form.append('RfidNumber', rfid);
        form.append('EquipmentNumber', equipmentNum);
        form.append('EquipmentName', equipmentName);
        form.append('Manufacturer', manufacturer);
        form.append('ModelNumber', model);
        form.append('SerialNumber', serial);
        form.append('PurchaseDate', purchaseDate.format('DD/MM/YYYY').toString());
        form.append('ExpiryDate', expiryDate.format('DD/MM/YYYY').toString());
        form.append('CertDueDate', calDate.format('DD/MM/YYYY').toString());
        // form.append('calPeriod', calPeriod);
        // form.append('calPeriodType', calPeriodType.toString());
        if (certFileBinary != undefined || certFileBinary != null) {
            form.append('CertificationFile', certFileBinary);
        }
        if (equipmentPhotoFileBinary != undefined || equipmentPhotoFileBinary != null) {
            form.append('EquipmentPhotoFile', equipmentPhotoFileBinary);
        }
        setEquipmentDetail(form)
            .then((respone) => {
                if ('error' in respone) {
                    console.log(respone.error);
                    alert("StatusCode: 400")
                    setOpen(false);
                }
                else {
                    console.log(respone?.data);
                    alert("Update Success")
                    setOpen(false);
                    navigate('/equipment-detail', { state: respone?.data?.id })
                }
            })
    }

    // const handleCalPeriodChange = (event: SelectChangeEvent) => {
    //     setCalPeriodType(event.target.value as string);
    // };

    const handleCertificationFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            uploadCertification(selectedFile);
        }
    };
    const handleEquipmentPhotoFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            uploadEquipmentPhoto(selectedFile);
        }
    };

    const fileUrl = (file: any) => {
        if (!(equipmentId == undefined || equipmentId == null)) {
            getFile(file.id).then((res) => {
                if (res?.data != undefined) {
                    const link = document.createElement('a');
                    link.href = res?.data?.url;
                    link.download = file.name;
                    link.click();
                }
            })
        }
    }

    const uploadCertification = (file: File) => {
        setCertFileName({ id: "", name: file.name });
        setCertFileBinary(file);
    };

    const uploadEquipmentPhoto = (file: File) => {
        setEquipmentPhotoFileName({ id: "", name: file.name });
        setEquipmentPhotoFileBinary(file);
    };
    const handleCertificationButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (certificationFileInputRef.current) {
            certificationFileInputRef.current.click();
        }
    };
    const handleEquipmentPhotoButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (equipmentPhotoFileInputRef.current) {
            equipmentPhotoFileInputRef.current.click();
        }
    };
    function setFileHref(file?: any): string {
        //console.log(file);
        if (file != null) {
            return file.id;
        }
        else {
            return "";
        }
    }

    const handleDDLonChange = (name: string) => {
        const matchType = equipmentTypeDDL?.data?.find((item: any) => item?.fullName === name);
        console.log(equipmentTypeDDL?.data);
        console.log(matchType.id);
        if (matchType != undefined) {
            console.log(matchType.id);
            setType(matchType);
        }
    }

    const handleRRTDDLonChange = (name: string) => {
        const matchType = realTimeTypeDDL?.find((item: any) => item?.name === name);
        if (matchType != undefined) {
            console.log(matchType.id);
            setRRT(matchType);
        }
    }

    // };
    const inputStyle = {
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        width: "25%",

    };
    const selectStyle = {
        borderRadius: "6px",
        height: "32px",
        width: "25%",
    };
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
        marginBottom: "28px",
        minWidth: "200px",
        maxWidth: "600px",
    };

    return (
        <MainContent type={equipmentPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    {!equipmentId && <BigHeading>Add New Equipment</BigHeading>}
                    {equipmentId && <BigHeading>Edit Equipment</BigHeading>}
                    {/* <SearchInput title={""} value={projectNum} setMethod={setProjectNum} /> */}
                    <FormDropDownList sameRowTitle={t("Type")} value={equipmentType?.fullName} displayEmpty={true} handleValueChange={(event: any) => handleDDLonChange(event?.target?.value)} items={equipmentTypeDDL?.data?.map((item: { fullName: any; }) => item.fullName)} />
                    { }
                    <FormDropDownList sameRowTitle={t("Device Type")} value={realTimeType?.name} displayEmpty={true} handleValueChange={(event: any) => handleRRTDDLonChange(event?.target?.value)} items={realTimeTypeDDL?.map((item: { name: any; }) => item.name)} />
                    {/* {<FormInput title={t("RFID No.")} value={rfid} setMethod={setRfid} />} */}
                    <FormInput title={t("Equipment No.")} value={equipmentNum} setMethod={setEquipmentNum} />
                    <FormInput title={t("Equipment Name")} value={equipmentName} setMethod={setEquipmentName} />
                    <FormInput title={t("Brand / Manufacturer")} value={manufacturer} setMethod={setManufacturer} />
                    <FormInput title={t("Model No.")} value={model} setMethod={setModel} />
                    <FormInput title={t("Serial No.")} value={serial} setMethod={setSerial} />
                    <FormDatePicker title={t("Purchase Date")} value={purchaseDate} setMethod={setPurchaseDate} />
                    <FormDatePicker title={t("Expiry Date")} value={expiryDate} setMethod={setExpiryDate} />
                    <FormDatePicker title={t("Next Cal. / Cert Due Date")} value={calDate} setMethod={setCalDate} />
                    {/* <Box sx={{ minWidth: 120, display: "flex" }}> */}
                    {/* <div style={containerStyle}>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {"Cal. Period: "}
                        </LabelContainer>
                        <input
                            value={calPeriod}
                            style={inputStyle}
                            onChange={(event) => {
                                setCalPeriod(event.target.value)
                            }}
                        />
                        <FormControl sx={selectStyle}>
                            <Select
                                value={calPeriodType}
                                onChange={handleCalPeriodChange}
                                style={{ backgroundColor: "white", height: "32px", width: "100%" }}
                            >
                                <MenuItem value={0}>Year</MenuItem>
                                <MenuItem value={1}>Month</MenuItem>
                            </Select>
                        </FormControl>
                    </div> */}
                    {/* </Box> */}
                    <ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Certification: ")}
                        </LabelContainer>
                        <input type="file" ref={certificationFileInputRef} onChange={handleCertificationFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "20px" }} onClick={handleCertificationButtonClick}>{t("Select File")}</DocumentButton>
                        {certFileBinary && <a style={{ marginLeft: "10px" }} onClick={() => fileUrl(certFileName)} target="_blank" rel="noopener noreferrer">{certFileName.name}</a>}
                        {certFileBinary &&
                            <IconButton onClick={() => setCertFileBinary(null)}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>
                    <ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Equipment Photo: ")}
                        </LabelContainer>
                        <input type="file" ref={equipmentPhotoFileInputRef} onChange={handleEquipmentPhotoFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "20px" }} onClick={handleEquipmentPhotoButtonClick}>{t("Select File")}</DocumentButton>
                        {equipmentPhotoFileBinary && <a style={{ marginLeft: "10px" }} onClick={() => fileUrl(equipmentPhotoFileName)} target="_blank" rel="noopener noreferrer">{equipmentPhotoFileName.name}</a>}
                        {equipmentPhotoFileBinary &&
                            <IconButton onClick={() => setEquipmentPhotoFileBinary(null)}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>
                    {/* <div style={{ height: "10px" }} /> */}
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={() => setOpen(true)}>{t("Save")}</ShortBlueButton>
                        <BackButton onClick={() => { navigate('/equipment') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
                <ModalConfirmationBox description={t("Are you sure to ADD NEW or EDIT contract?")} open={open} onClose={() => setOpen(false)} onConfirm={handleOnComfirm} />
            </BackgroundStyle>
        </MainContent>
    );
};

export default AddEquipmentPage;